var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('iTable',{ref:"iTable",attrs:{"table-data":_vm.dataList,"columns":_vm.columns,"pagination":_vm.pagination,"tabletype":"2","other-height":230,"border":false},on:{"handleTableChange":_vm.handleTableChange,"readAllClick":_vm.readAll,"msgRead":_vm.msgRead,"starFn":_vm.starFn}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }